import {
  Anchor,
  Button,
  Card,
  Grid,
  Heading,
  Layout,
} from '@design-systems/canvas-ui'
import { LogoSlot } from 'App/LogoSlot'
import { isPol } from 'App/POLAccountSwitcher'
import { PageLayout } from '@plm-core/utils'

const UnauthorizedPage = () => (
  <Layout>
    <Layout.GlobalHeader logoSlot={<LogoSlot />} />
    <Layout.Body>
      <PageLayout>
        <Grid.Container>
          <Grid.Item size={{ xs: 12 }}>
            <Heading size={1}>You don't have access to PLM</Heading>
          </Grid.Item>
          <Grid.Item size={{ xs: 12 }}>
            <Card className="hc8-pa-4x">
              <Grid.Container>
                <Grid.Item size={{ xs: 12 }}>
                  <p>
                    Your account is not currently authorized to use PLM.{' '}
                    {!isPol && (
                      <>To get access, submit a request through myAccess.</>
                    )}
                  </p>
                </Grid.Item>
                <Grid.Item size={{ xs: 12 }}>
                  {!isPol && (
                    <Button
                      variant="primary"
                      as={Anchor}
                      href="https://go/myaccess/request-access/quick-checkout/APP-PLM-USER"
                    >
                      Request access
                    </Button>
                  )}
                </Grid.Item>
              </Grid.Container>
            </Card>
          </Grid.Item>
        </Grid.Container>
      </PageLayout>
    </Layout.Body>
  </Layout>
)

export default UnauthorizedPage
